import { TResponse } from '@r1-frontend/do-request/core/types';
import { captureQueryError } from '@r1-frontend/do-request/error';

import { IBundlePackage } from '@r1-frontend/shared/types/tariff/bundle/IBundlePackage';
import { IInternetPackage } from '@r1-frontend/shared/types/tariff/mono/IInternetPackage';

import contentRequest from '~/src/api/requests/contentRequest';
import { getAccessModeByRights } from '~/src/helpers/accessMode';

export type TDataResponse = TResponse<{
    bundles: Record<string, IBundlePackage>,
    mono: IInternetPackage[],
}, any>;

export interface IGetCitiesTariffsQueryParams {
    availableAuth?: number, // Фильтр доступа для авторизованных пользователей
    availableNew?: number, // Фильтр доступа для неавторизованных
    selfOrder?: number, // Фильтр доступа для полной покупки (по-умолчанию - false)
    isBackcallAvailable?: number, // Доступно для оформления в обратном звонке (по-умолчанию - не учитывается, 1 да, 0 нет, * не переданный параметр - отсутствие фильрации по параметру)
    ignoreAvailable?: number, // Игонорировать параметр sale у пакетов и available у моно, это нужно чтобы получить все тарифы какие пришли от биллинга (по-умолчанию - 0)
    isLowSpeed?: number, // Если передан этот параметр, то вернутся тарифы со скорость до 100. По умолчанию - 0, чтобы заработало нужно передать 1
    restrictIgnore?: number, // Если передан этот параметр, то вернуться тарифы со скорость до 100 который отключены. По умолчанию - 0, чтобы заработало нужно передать 1
    landingAvailable?: string, // Если передан этот параметр, то вернуться тарифы, которые доступны из лендингов(берется из url query) (по-умолчанию - не учитывается, 1 да)
}

export const getCitiesTariffs = async(providerId: number, params?: IGetCitiesTariffsQueryParams): Promise<TDataResponse> => {
    const url = '/v1/cities/tariffs';

    try {
        const response = await contentRequest.get(url, {
            params: {
                providerId,
                accessMode: getAccessModeByRights({}),
                ...(params || {}),
            },
        });

        return {
            isSuccess: true,
            payload: response.data,
        };
    } catch (error) {
        return captureQueryError(error);
    }
};
